import * as React from 'react';
import { memo } from 'react';

const SvgAward = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.21 13.89 7 23l5-3 5 3-1.21-9.12", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgAward);

export { Memo as default };
